import { Component, OnInit, EventEmitter, Output, ViewChild, Input } from '@angular/core';
import { AuthService } from '../../_service/auth.service';
import { AuthConfigService } from '../../_service/auth-config.service';
import { Router } from '@angular/router';
import { AlertifyService } from '../../_service/alertify.service';
import { LoginComponent } from 'src/app/login/login.component';
import { MatDialog } from '@angular/material';
import { UserProfileComponent } from 'src/app/users/user-profile/user-profile.component';
import { ResetPasswordComponent } from 'src/app/resetPassword/resetPassword.component';
import { UserUpdatepasswordComponent } from '../../users/user-updatepassword/user-updatepassword.component';
import {
  FormControl,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { InventoryProductComponent } from 'src/app/inventory-product/inventory-product.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() sidenavToggle = new EventEmitter<void>();
  @ViewChild(LoginComponent, { static: true }) logininfo: LoginComponent;
  @ViewChild(InventoryProductComponent, { static: true }) inventoryProd: InventoryProductComponent;

  constructor(
    public authService: AuthService,
    public authConfigService: AuthConfigService,
    private router: Router,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    public fb: FormBuilder
  ) {
    this.searchBarForm = fb.group({
      searchStringControl: new FormControl({value: '', disabled: false}, [])
    });
  }

  generic: any;
  selected: any;
  productName: any;
  selectedParameter: any;
  value = '';
  searchString;
  searchBarForm: FormGroup;
  selectedDropdownValue: any;
  allProducts: any = [];
  selectedSearchParameter: any;
  isLoading: true;
  isSearchBoxHidden: boolean;

  // selected = 'All Records'
  ngOnInit() {
    this.selectedParameter = 'productName';
    this.selectedSearchParameter = 'productName';
    this.disableSearchbox();
  }
  
  refreshSearchState() {
    this.disableSearchbox();
  }

  searchForProducts(selectedValue: string) {
    this.changeEvent(this.selectedSearchParameter, selectedValue);
  }

  onSelectProductParameter(event) {
    this.selectedSearchParameter = event.value;
  }

  changeEvent = (selectedSearchParameter, selectedValue) => {};

  disableSearchbox() {
    if (this.selectedParameter === 'searchString') {
      this.value = '';
      this.searchString = '';
      this.searchBarForm.controls['searchStringControl'].disable();
    } else {
      this.searchBarForm.controls['searchStringControl'].enable();
    }
  }

  onSelectParameter(event) {
    console.log(event.value);
    this.selectedParameter = event.value;
    this.selectedSearchParameter = event.value;
    this.disableSearchbox();
    if (event.value === 'productName') {
      this.selectedDropdownValue = event.value;
    } else if (event.value === 'productCode') {
      this.selectedDropdownValue = event.value;
    } else if (event.value === 'manufacturer') {
      this.selectedDropdownValue = event.value;
    } else if (event.value === 'casNo') {
      this.selectedDropdownValue = event.value;
    }
  }

  clearInputBox() {
    this.value = '';
    this.searchString = '';
    this.searchBarForm.controls['searchStringControl'].setValue('');
  }

  windowsLoggin() {
    return this.authService.windowsAuthentication();
  }

  performLogin() {
    if (this.authConfigService.isWindowsAuthMode()) {
      this.authService.windowsAuthentication();
    } else {
      this.openLoginModalWindow();
    }
  }

  /**
   * Checks if the current mode is Windows authentication
   */
  isWindowsAuthMode(): boolean {
    return this.authConfigService.isWindowsAuthMode();
  }

  /**
   * Checks if the current mode is credentials authentication
   */
  isCredentialsAuthMode(): boolean {
    return this.authConfigService.isCredentialsAuthMode();
  }

  /**
   * Gets the authentication mode for debugging/display purposes
   */
  getAuthMode(): string {
    return this.authConfigService.getAuthMode();
  }

  /**
   * Gets the server type for debugging/display purposes
   */
  getServerType(): string {
    return this.authConfigService.getServerType();
  }

  /**
   * Gets the appropriate text for the login button based on current state
   */
  getLoginButtonText(): string {
    if (this.authService.isLoading) {
      return 'Login';
    }
    
    if (!this.authConfigService.isAuthModeDetected()) {
      return 'Loading...';
    }
    
    return 'Login';
  }


  onToggleSidenav() {
    this.sidenavToggle.emit();
  }

  loggedIn() {
    return this.authService.loggedIn();
  }

  isInActive() {
    if (this.authService.decodedToken.role === 'InActive') {
      return true;
    } else {
      return false;
    }
  }

  UserTypes() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return false;
    }
  }

  adminLink() {
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return false;
    }
    return true;
  }

  showSDSRequestLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  showProfileLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  adminDropDownLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  hideLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  loggedInWindowsUser() {
    return this.authService.loggedInWindowsUser();
  }

  isWindowsUser() {
    if (this.authService.decodedToken.actort === 'True') {
      return true;
    }
    if (this.authService.decodedToken.actort === 'False') {
      return false;
    }
  }

  logout() {
    this.authService.logout();
    this.alertify.message('Logged out Successfully');
    this.router.navigate(['/search']);
  }

  openUserProfileModalWindow(id) {
    this.dialog.open(UserProfileComponent, {
      width: '1000px',
      data: {
        user: id
      }
    });
  }

  openResetPasswordModalWindow(id) {
    this.dialog.open(ResetPasswordComponent, {
      width: '500px',
      data: {
        user: id
      }
    });
  }

    openChangePasswordModalWindow(id) {
    this.dialog.open(UserUpdatepasswordComponent, {
      width: '500px',
      data: {
        user: id
      }
    });
  }

  openLoginModalWindow() {
    this.dialog.open(LoginComponent, {
      width: '500px'
    });
  }
}